
<div class="ticket-category"
[ngClass]="{ 'most-popular':isMostPopular }"
(click)="handleClick()">
  <span *ngIf="isMostPopular">{{'label_most_popular' | i18next}}</span>
  <button>
    {{ title | i18next }}
  </button>
  <p>
    {{ description | i18next }}
  </p>
</div>
